import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class InputTextService {

  constructor(
    @Inject('INPUT_TEXT_FORMAT') private format: string = 'M',
    @Inject('INPUT_TEXT_SHOW_LABEL') private showLabel: boolean = true,
    @Inject('INPUT_TEXT_BTN_ENABLE') private btnEnable: boolean = false,
    @Inject('INPUT_TEXT_BOLD') private bold: boolean = false,
    @Inject('INPUT_TEXT_TEXT_RIGHT') private textRight: boolean = false,
    @Inject('INPUT_TEXT_VALIDATOR_MESSAGE') private validatorMessage: boolean = false,
    @Inject('INPUT_TEXT_TOOLTIP_MESSAGE') private tooltipMessage: boolean = true,
    @Inject('INPUT_TEXT_SUBMITTED') private submitted: boolean = true,
    @Inject('INPUT_TEXT_VALIDATOR_ALERT') private validatorAlert: boolean = false
  ) {
  }

  public getFormat(): string {
    return this.format;
  }
  public getShowLabel(): boolean {
    return this.showLabel;
  }
  public getBtnEnable(): boolean {
    return this.btnEnable;
  }
  public getBold(): boolean {
    return this.bold;
  }
  public getTextRight(): boolean {
    return this.textRight;
  }
  public getValidatorMessage(): boolean {
    return this.validatorMessage;
  }
  public getTooltipMessage(): boolean {
    return this.tooltipMessage;
  }
  public getSubmitted(): boolean {
    return this.submitted;
  }
  public getValidatorAlert(): boolean {
    return this.validatorAlert;
  }
  
  
}